import { getConfiguration, verifyExtend } from "./extend-utils.js";
import { initProductOffer } from "./extend-product.js";
import { initCartOffer } from "./extend-cart.js";

function initAftermarket() {
    try {
        verifyExtend();

        // Get params from URL
        const params = (new URL(document.location)).searchParams;

        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
            ? params.get('leadToken')
            : params.get('leadtoken');

        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError( error.message);
    }
}

window.addEventListener('DOMContentLoaded', () => {
    try {
        const storeId = 'bf68cd76-90b7-4ed7-b925-f8bc42aad631';
        const environment = 'production';

        window.Extend.config({ storeId, environment});

        const config = getConfiguration();

        if (config.aftermarketModalEnabled)
            initAftermarket();

        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        if (sessionStorage.getItem('extend.debug'))
            console.error(err);
    }
});